/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ShipmentDtoModel } from './shipment-dto.model';

export class ShipmentOrderDtoModel extends ShipmentDtoModel {

  customsDuty: boolean | undefined = undefined;

  customsRegime: boolean | undefined = undefined;

}
